import { getKennzahlenVerfuegbar } from '../../main/functions/getKennzahlenVerfuegbar';
import { IDs } from '../../helpers/IDs';
import { KennzahlenAuswahl } from '../datenauswertung/elements/KennzahlenAuswahl';
import { getFilteredKennzahlen } from '../datenauswertung/elements/getFilteredKennzahlen';
import * as React from 'react';
import { i18n } from '../../i18n/i18n';
import formStyle from '../../core/forms/style/WForm.less';

interface ZusatztoolsEntwicklungsfahrplanSpaltenEditorProps extends React.ClassAttributes<any> {
    data: any;
    onSpaltenDataChange: (spalten_auswahl: number, spalten_data: any) => void;
    spalten_auswahl: number;
    spalten_data_all: any;
}

interface ZusatztoolsEntwicklungsfahrplanSpaltenEditorState {
    showEkz: string;
    showAllEkz: boolean;
}

export class ZusatztoolsEntwicklungsfahrplanSpaltenEditor extends
    React.Component<ZusatztoolsEntwicklungsfahrplanSpaltenEditorProps, ZusatztoolsEntwicklungsfahrplanSpaltenEditorState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showEkz: 'nein',
            showAllEkz: false
        };
    }

    private maxMassnahmen = 5;
    private maxMassnahmen2 = 2;

    componentDidUpdate(prevProps: any, prevState: any) {
        const { spalten_auswahl, spalten_data_all } = this.props;
        if (+spalten_auswahl === 0 && spalten_data_all && spalten_data_all[0] && spalten_data_all[0].showEkz) {
            if (this.state.showEkz !== spalten_data_all[0].showEkz) {
                this.setState({ showEkz: spalten_data_all[0].showEkz });
            }
        }
    }

    getJahre(): Array<number> {
        const kennzahlen_berechnet = this.props.data[IDs.KENNZIFFERN_BERECHNET] || [];
        const jahre: Array<number> = [];
        (this.props.data[IDs.ENT_KENNZAHLEN_DEFINTION] || []).forEach((item: any) => {
            if ((+item.is_berechnet || null) === 1) {
                Object.keys(kennzahlen_berechnet).forEach((j: string) => {
                    if (+j > 0 && jahre.indexOf(+j) === -1 && kennzahlen_berechnet[j][item.kuerzel]) {
                        const kz_verfuegbar = getKennzahlenVerfuegbar(kennzahlen_berechnet, +j);
                        if ((+kz_verfuegbar[item.kuerzel] || null) !== 1) {
                            jahre.push(+j);
                        }
                    }
                });
            }
        });
        return jahre.sort();
    }

    getMassnahmen(): Array<JSX.Element> {
        const elements: Array<JSX.Element> = [];
        for (let i = 0; i < this.maxMassnahmen; i++) {
            const data = this.props.spalten_data_all[this.props.spalten_auswahl] || {};
            const massnahme = data && data.massnahmen && data.massnahmen[i] ? data.massnahmen[i] : '';
            elements.push(
                <div key={`massnahme-${i}`} style={{ marginTop: 5 }}>
                    <span style={{ display: 'inline-block', width: 200, verticalAlign: 'top' }}>{i18n('Maßnahme', 'sys')} {i + 1}</span>
                    <textarea
                        style={{
                            fontSize: 11, width: 200, border: '1px solid var(--color-wform-field-border-color)',
                            borderRadius: 'var(--border-radius-form-elements)', boxSizing: 'border-box'
                        }}
                        value={massnahme}
                        rows={2}
                        cols={20}
                        onChange={(evt: any) => {
                            if (!data.massnahmen) {
                                data.massnahmen = [];
                            }
                            data.massnahmen[i] = evt.target.value;
                            this.props.onSpaltenDataChange(this.props.spalten_auswahl, data);
                        }}
                    />
                    {this.checkWordLength(massnahme || '')}
                </div>
            );
            if (massnahme === '') {
                break;
            }
        }
        return elements;
    }

    getMassnahmen2(): Array<JSX.Element> {
        const elements: Array<JSX.Element> = [];
        const data = this.props.spalten_data_all[this.props.spalten_auswahl];
        const inherit = data && data.massnahmen2_inherit ? true : false;
        elements.push(
            <div key={`massnahme2-`} style={{ marginTop: 5 }}>
                <span style={{ display: 'inline-block', width: 200, verticalAlign: 'top' }}>{i18n('Maßnahmen übernehmen', 'sys')}</span>
                <input
                    type='checkbox' checked={inherit}
                    onChange={(evt: any) => {
                        data.massnahmen2_inherit = evt.target.checked;
                        this.props.onSpaltenDataChange(this.props.spalten_auswahl, data);
                    }}
                />
            </div>
        );
        const massnahmen = data && Array.isArray(data.massnahmen2) ? data.massnahmen2 : [];
        for (let i = 0; i < this.maxMassnahmen2; i++) {
            elements.push(
                <div key={`massnahme2-${i}`} style={{ marginTop: 5 }}>
                    <span style={{ display: 'inline-block', width: 200, verticalAlign: 'top' }}>{i18n('Maßnahme', 'sys')} {i + 1}</span>
                    <textarea
                        style={{
                            fontSize: 11, width: 200, border: '1px solid var(--color-wform-field-border-color)',
                            borderRadius: 'var(--border-radius-form-elements)', boxSizing: 'border-box'
                        }}
                        value={massnahmen[i] ? massnahmen[i] : ''}
                        rows={2}
                        cols={20}
                        onChange={(evt: any) => {
                            if (!data.massnahmen2) {
                                data.massnahmen2 = [];
                            }
                            data.massnahmen2[i] = evt.target.value;
                            this.props.onSpaltenDataChange(this.props.spalten_auswahl, data);
                        }}
                        disabled={inherit}
                    />
                    {this.checkWordLength(massnahmen[i] || '')}
                </div>
            );
            if (!massnahmen[i] || massnahmen[i] === '') {
                break;
            }
        }
        return elements;
    }

    render(): JSX.Element {
        const { data, spalten_auswahl, spalten_data_all } = this.props;
        const spalten_data = spalten_data_all[spalten_auswahl] || {};

        // const ekzTypen = Object.keys(IDs.KENNZIFFERN);
        const jahre = this.getJahre();
        const name = spalten_data && spalten_data.name ? spalten_data.name : '';
        const jahr = spalten_data && spalten_data.jahr ? spalten_data.jahr : jahre[0] || '';
        let ekz: any = spalten_data && typeof spalten_data.ekz === 'object' ? spalten_data.ekz : {};
        let ekzKuerzel: string, ekzEinheit: string;
        const kennzahlen = this.props.data[IDs.ENT_KENNZAHLEN_DEFINTION].sort((a: any, b: any) => a.name > b.name);
        const kennzahlenFiltered = getFilteredKennzahlen(jahr, data, this.state.showAllEkz);

        if (Object.keys(spalten_data_all).length > 0) {
            const firstCol = spalten_data_all[0];
            const ekzData = data[IDs.KENNZIFFERN_BERECHNET];
            // const jahr = typeof firstCol.name === 'string' ? firstCol.name.substr(-4) : '';
            ekzKuerzel = firstCol.ekzKuerzel ? firstCol.ekzKuerzel : kennzahlenFiltered && kennzahlenFiltered.length > 0 ? kennzahlenFiltered[0].kuerzel : undefined;
            const ekzFnd = kennzahlen.find((k: any) => k.kuerzel === ekzKuerzel);
            ekzEinheit = ekzFnd ? ekzFnd.einheit : '';

            if (spalten_auswahl === 0) {
                ekz = ekzData[jahr] || {};
                // console.log('SEKZ', ekzKuerzel, spalten_data, ekzData, ekz);
                if (spalten_data && (!spalten_data.ekz || spalten_data.ekz[ekzKuerzel] !== ekz[ekzKuerzel])) {
                    if (!isNaN(ekz[ekzKuerzel])) {
                        spalten_data.ekz = ekz;
                        this.props.onSpaltenDataChange(spalten_auswahl, spalten_data);
                        return <div>{i18n('Warten ...', 'sys')}</div>;
                    }
                }
            }
        }
        // console.log(ekz, ekzKuerzel, ekz[ekzKuerzel]);
        const isFirstCol = this.props.spalten_auswahl === 0 ? true : false;

        if (this.state.showEkz === 'ja') {
            // console.log(this.props.spalten_auswahl, spalten_data);
            // this.props.onSpaltenDataChange(this.props.spalten_auswahl, spalten_data);
        }

        const fndEkz = (this.props.data[IDs.ENT_KENNZAHLEN_DEFINTION] || []).find((k: any) => k.kuerzel === ekzKuerzel);
        const ekzShowName = fndEkz ? (String.fromCharCode(402) + ' ' + fndEkz.name) : '';

        return (
            <div
                key={'EntwicklungsfahrplanEditor_' + spalten_auswahl}
                style={{ marginTop: 5 }}>
                <div>
                    <span style={{ display: 'inline-block', width: 200 }}>{i18n('Bezeichnung/Zeitraum', 'sys')}</span>
                    <input
                        style={{ fontSize: '11px', width: 200, boxSizing: 'border-box' }}
                        type='text'
                        value={name}
                        onChange={(evt: any) => {
                            spalten_data.name = evt.target.value;
                            this.props.onSpaltenDataChange(this.props.spalten_auswahl, spalten_data);
                        }}
                    />
                </div>
                {isFirstCol &&
                    <div style={{ marginTop: 5 }}>
                        <span style={{ display: 'inline-block', width: 200 }}>{i18n('EKZ anzeigen', 'sys')}</span>
                        <select
                            style={{ width: 200, boxSizing: 'border-box' }}
                            value={this.state.showEkz}
                            onChange={(e: any) => {
                                this.setState({ showEkz: e.target.value });
                                spalten_data.showEkz = e.target.value;
                                this.props.onSpaltenDataChange(this.props.spalten_auswahl, spalten_data);
                            }}
                        >
                            <option value={'ja'}>ja</option>
                            <option value={'nein'}>nein</option>
                        </select>
                    </div>
                }
                {(isFirstCol && this.state.showEkz === 'ja') &&
                    <div style={{ marginTop: 5 }}>
                        <span style={{ display: 'inline-block', width: 200 }}>{i18n('Basisjahr', 'sys')}</span>
                        <select
                            style={{ width: 200, boxSizing: 'border-box' }}
                            value={jahr}
                            onChange={(evt: any) => {
                                spalten_data.jahr = +evt.target.value;
                                this.props.onSpaltenDataChange(this.props.spalten_auswahl, spalten_data);
                            }}
                        >
                            {(jahre.length < 1) &&
                                <option key='jahr-' value=''>{`<keine Daten>`}</option>
                            }
                            {jahre.map((j: number, idx: number) =>
                                <option key={`jahr-${idx}`} value={j}>{j}</option>
                            )}
                        </select>
                    </div>
                }
                {this.state.showEkz === 'ja' &&
                    <div style={{ marginTop: 5, display: 'flex' }}>
                        <span style={{ display: 'inline-block', width: 200 }}>EKZ</span>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {isFirstCol ? <KennzahlenAuswahl
                                jahr={jahr}
                                disabled={!isFirstCol}
                                data={this.props.data}
                                padding={0}
                                width={200}
                                changeInvalidEkzSel={true}
                                kennzahlSelected={ekzKuerzel}
                                onKennzahlChange={(ekzSel: string) => {
                                    // spalten_data.ekzKuerzel = ekzSel;
                                    // this.props.onSpaltenDataChange(spalten_auswahl, spalten_data);
                                    Object.keys(spalten_data_all).forEach((key: string) => {
                                        if (spalten_data_all[key] && spalten_data_all[key].ekzKuerzel !== ekzSel) {
                                            spalten_data_all[key].ekzKuerzel = ekzSel;
                                            this.props.onSpaltenDataChange(+key, spalten_data_all[key]);
                                        }
                                    });
                                }}
                                fontSize={11}
                                showAll={this.state.showAllEkz}
                            /> : <div style={{ fontSize: '11px' }}>{ekzShowName}</div>}
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <input
                                    disabled={isFirstCol}
                                    style={{ width: 200, boxSizing: 'border-box', fontSize: '11px', marginTop: 5, textAlign: 'right' }}
                                    type='text'
                                    value={ekz[ekzKuerzel] ? ekz[ekzKuerzel] : ''}
                                    onChange={(evt: any) => {
                                        ekz[ekzKuerzel] = evt.target.value;
                                        spalten_data.ekz = ekz;
                                        this.props.onSpaltenDataChange(this.props.spalten_auswahl, spalten_data);
                                    }}
                                />
                                <span
                                    className={formStyle.inputUnitInformation}
                                    style={{ fontSize: 11, marginTop: 5, marginLeft: -195, display: 'inline-flex', alignItems: 'center' }}
                                >
                                    {ekzEinheit}
                                </span>
                            </div>
                        </div>
                    </div>
                }
                <div
                    style={{
                        display: 'inline-block', width: 420, backgroundColor: '#bbb', color: '#fff', padding: 3,
                        marginTop: 10, marginBottom: 10, borderRadius: 5
                    }}
                >
                    {i18n('Energiebezogene Maßnahmen', 'sys')}
                </div>
                {this.getMassnahmen()}
                <div
                    style={{
                        display: 'inline-block', width: 420, backgroundColor: '#bbb', color: '#fff', padding: 3,
                        marginTop: 10, marginBottom: 10, borderRadius: 5
                    }}
                >
                    {i18n('Nicht energiebezogene Maßnahmen', 'sys')}
                </div>
                {this.getMassnahmen2()}
            </div>
        );
    }

    checkWordLength(text: string) {
        const overlong = text.split(' ').some((w: string) => w.length > 25);
        if (overlong) {
            return <p style={{ fontSize: '0.7em', fontStyle: 'italic', margin: 0, color: 'gray', width: 400 }}>
                {i18n('Bitte trennen Sie zu lange Wörter manuell, indem Sie einen Bindestrich + Leerzeichen eingeben.', 'sys')}
            </p>
        }
        return null;
    }
}
